<template>
    <PageSidebar>
        <template #sidebarTitle>
            <div class="space-x-3">
                <span>{{ $t("legal.menu.terms") }} </span>
            </div>
        </template>
        <template #sidebarMain>
            <CardToggle :title="$t('legal.privacy.store_features')">
                <div class="space-y-5">
                    <FormToggleSm
                        :title="$t('legal.privacy.register_account')"
                        v-model="legal.registerAccount"
                    />
                    <FormToggleSm
                        :title="$t('legal.privacy.newsletter')"
                        v-model="legal.newsletter"
                    />
                    <FormToggleSm
                        :title="$t('legal.privacy.contact_form')"
                        v-model="legal.contactForm"
                    />
                    <FormToggleSm
                        :title="$t('legal.privacy.add_comments')"
                        v-model="legal.addComments"
                    />
                    <FormToggleSm
                        :title="$t('legal.privacy.rate_products')"
                        v-model="legal.rateProducts"
                    />
                    <FormToggleSm :title="$t('legal.privacy.forum')" v-model="legal.forum" />
                    <FormToggleSm :title="$t('shared.others')" v-model="legal.otherTools" />
                    <FormTextArea
                        v-if="legal.otherTools"
                        :title="$t('legal.privacy.other_label')"
                        v-model="legal.otherToolsName"
                        :rows="5"
                    />
                </div>
            </CardToggle>
            <CardToggle :title="$t('legal.privacy.products')">
                <div class="space-y-5">
                    <FormToggleSm
                        :title="$t('legal.privacy.new_physical_products')"
                        v-model="legal.newProducts"
                    />
                    <FormToggleSm
                        :title="$t('legal.privacy.used_physical_products')"
                        v-model="legal.usedProducts"
                    />
                    <FormToggleSm
                        :title="$t('legal.privacy.digital_goods')"
                        v-model="legal.digitalProducts"
                    />
                    <FormToggleSm
                        :title="$t('legal.privacy.guarantee')"
                        v-model="legal.guarantee"
                    />
                    <div class="grid grid-cols-2 gap-2">
                        <FormInput placeholder="24" v-model="legal.guaranteeDuration" />
                        <FormSelect
                            :options="periods"
                            :value="legal.guaranteePeriod"
                            v-model="legal.guaranteePeriod"
                        />
                    </div>
                </div>
            </CardToggle>
            <CardToggle :title="$t('shared.general')">
                <div class="space-y-5">
                    <FormToggleSm :title="$t('legal.terms.based_eu')" v-model="legal.basedEu" />

                    <FormTextArea
                        v-if="!legal.basedEu"
                        :title="$t('legal.terms.representative_details')"
                        :placeholder="$t('legal.terms.representative_example')"
                        v-model="legal.representative"
                        :rows="5"
                    />

                    <FormToggleSm
                        :title="$t('legal.terms.easycart_integration')"
                        v-model="legal.easycart"
                    />
                    <FormToggleSm
                        :title="$t('legal.terms.individual_price')"
                        :tooltip="$t('legal.terms.individual_price_info')"
                        v-model="legal.individualPrice"
                    />
                    <FormToggleSm
                        :title="$t('legal.terms.moderate_content')"
                        v-model="legal.moderateContent"
                        :help="$t('legal.terms.moderate_content_info')"
                    />

                    <FormTextArea
                        v-if="legal.moderateContent"
                        :title="$t('legal.terms.moderate_content_example')"
                        :placeholder="$t('legal.terms.moderate_content_placeholder')"
                        v-model="legal.moderateRules"
                        :rows="10"
                    />

                    <FormTextArea
                        :title="$t('legal.terms.other_procedures')"
                        :help="$t('legal.terms.other_procedures_info')"
                        v-model="legal.otherProcedures"
                        :rows="5"
                    />
                </div>
            </CardToggle>

            <CardToggle :title="$t('legal.pages_terms.extra_title')">
                <div class="space-y-5">
                    <p class="ct-text">
                        {{ $t("legal.pages_terms.extra_info") }}
                    </p>
                    <FormToggleSm
                        :title="$t('legal.pages_terms.extra')"
                        v-model="legal.userTerms"
                    />
                    <template v-if="legal.userTerms">
                        <FormInput
                            :title="$t('legal.pages_terms.extra_label')"
                            :placeholder="$t('legal.pages_terms.extra_placeholder')"
                            v-model="legal.userTermsMenu"
                            :help="$t('legal.pages_terms.extra_help')"
                        />
                        <FormInput
                            :title="$t('legal.pages_terms.extra_menu')"
                            :placeholder="$t('legal.pages_terms.extra_placeholder')"
                            v-model="legal.userTermsTitle"
                            :help="$t('legal.pages_terms.extra_menu_help')"
                        />
                        <FormTextArea
                            :title="$t('legal.pages_terms.extra_content_label')"
                            v-model="legal.userTermsContent"
                            :placeholder="$t('legal.pages_terms.extra_content_placeholder')"
                            :rows="10"
                            :help="$t('legal.pages_terms.extra_content_help')"
                        />
                    </template>
                </div>
            </CardToggle>
        </template>
        <template #sidebarFooter>
            <cSaveButton @save="saveSnapshot" :disabled="!hasChanges" />
        </template>
    </PageSidebar>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { PageSidebar } from "@easy/ui/page-components";
import { FormToggleSm, FormInput, FormTextArea, FormSelect } from "@easy/ui/forms";
import { CardToggle } from "@easy/ui/cards";
import cSaveButton from "@/shared/components/cSaveButton.vue";

export default {
    components: {
        PageSidebar,
        FormToggleSm,
        FormInput,
        FormTextArea,
        CardToggle,
        FormSelect,
        cSaveButton,
    },
    computed: {
        ...mapState("legal", ["legal", "hasChanges"]),
        periods() {
            return [
                { label: this.$t("legal.privacy.months"), value: "months" },
                { label: this.$t("legal.privacy.years"), value: "years" },
                { label: this.$t("legal.privacy.weeks"), value: "weeks" },
            ];
        },
    },
    methods: {
        ...mapActions("legal/projects", ["saveSnapshot"]),
    },
};
</script>
